import React from "react";
import ProductDetailContainer from "../containers/ProductDetailContainer";

export default function ProductDetail() {
  return <ProductDetailContainer />;
}
